import { render, staticRenderFns } from "./NumberReport.vue?vue&type=template&id=6f6b6c4c&scoped=true&"
import script from "./NumberReport.vue?vue&type=script&lang=js&"
export * from "./NumberReport.vue?vue&type=script&lang=js&"
import style0 from "./NumberReport.vue?vue&type=style&index=0&id=6f6b6c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b6c4c",
  null
  
)

component.options.__file = "NumberReport.vue"
export default component.exports